import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { authInterceptor } from '@core/auth';
import { httpErrorInterceptor } from '@core/interceptors';
import { AppChromeService, ResponsiveService } from '@core/services';
import { ModalService } from '@shared/services';

import { appRouterProviders } from './app.routing';
import { AppSettings } from './app.settings';
import { MaterialModule } from './material.module';
import { SharedModule } from './shared/shared.module';
import { FilterPanelModule } from '@libs/filter-panel';
import { CustomOverlayContainer } from '@layout';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, httpErrorInterceptor])),
    importProvidersFrom(
      BrowserAnimationsModule,
      MaterialModule,
      FilterPanelModule,
      SharedModule,
      NgxMatSelectSearchModule
    ),
    appRouterProviders,
    AppChromeService,
    AppSettings,
    ModalService,
    ResponsiveService,
    {
      provide: OverlayContainer,
      useClass: CustomOverlayContainer,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill', subscriptSizing: 'dynamic' },
    },
  ],
};
